import { Loader } from "@components/loader/loader";
import { PressCardExample } from "@components/press_card/press_card_example";
import { PressItemForm } from "@components/press_item_form/press_item_form";
import { useFetchPressItem } from "@hooks/use_fetch_press_item";
import React, { type FC } from "react";

interface PressItemUpdatePageProps {
  id: string | null;
}
const PressItemUpdatePage: FC<PressItemUpdatePageProps> = ({ id }) => {
  if (!id) {
    throw "ID is required";
  }
  const { pressItem, loading, error: _e } = useFetchPressItem({ id });

  if (loading) {
    return <Loader />;
  }
  if (!pressItem) {
    return null;
  }

  return (
    <div className="content">
      <header>
        <h1>Update Press "{pressItem.tagline}"</h1>
      </header>
      <p>This page is where you can edit an existing press item.</p>
      <div className="press-item--prelude">
        <PressItemForm pressItem={pressItem} />
        <PressCardExample />
      </div>
    </div>
  );
};

export { PressItemUpdatePage };
